import Axios from "axios";
import cleanEmptyStrings from "../utils/cleanEmptyStrings";

const axios = Axios.create({
  baseURL: process.env.REACT_APP_SITE_API,
});

const setAuthHeader = (header) => {
  axios.defaults.headers.common.Authorization = header;
};

const getBible = (id) =>
  axios.get(`bibles/${id}`).then((result) => result.data.bible);

const getSite = (id) =>
  axios.get(`sites/${id}`).then((result) => result.data.site);

const listLanguages = () =>
  axios.get(`languages`).then((result) => result.data.languages);

const listSites = () => axios.get("sites").then((result) => result.data.sites);

const listBibles = () =>
  axios.get("bibles").then((result) => result.data.bibles);

const createSite = (siteData) =>
  axios
    .post("sites", JSON.stringify(cleanEmptyStrings(siteData)))
    .then((result) => result.data);

const refreshBibles = () =>
  axios.post("bibles/refresh").then((result) => result.data);

const updateBible = (bibleId, metadata) =>
  axios
    .post(`bibles/${bibleId}`, JSON.stringify(cleanEmptyStrings(metadata)))
    .then((result) => result.data);

const updateSite = (siteData) =>
  axios
    .post(`sites/${siteData.id}`, JSON.stringify(cleanEmptyStrings(siteData)))
    .then((result) => result.data);

const ApiService = {
  axios,
  getBible,
  listBibles,
  listLanguages,
  refreshBibles,
  getSite,
  listSites,
  createSite,
  updateSite,
  updateBible,
  setAuthHeader,
};

export default ApiService;
